import { useContext, useEffect, useState } from "preact/hooks";
import { Recovery } from "../index";

import { CountryPhone } from "../CountryPhone";
import useStepRequest from "../Hooks/useStepRequest"
import Button from "../Button";

import styles from "./Step.module.css"

const PhoneStep = () => {
  const { selectedCountry, phone, setError } = useContext(Recovery)

  const [listener, setListener] = useState(null)
  const { step1 } = useStepRequest()

  useEffect(() => {
    if(listener) {
      document.removeEventListener('keydown', enterListener)
    }
    document.addEventListener('keydown', enterListener)
    setListener(true)
    return () => {
      document.removeEventListener('keydown', enterListener)
    }
  }, [selectedCountry])

  const enterListener = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      submitStep1(event.target.rawValue)
      event.preventDefault();
    }
  }

  // Валидация номера телефона
  const phoneValidation = (phone) => {
    if(!phone || phone === selectedCountry.phone_code) {
      setError('Введите номер телефона')
      return false
    }
    if (phone.length < 12) {
      setError('Некорректный номер телефона')
      return false
    }
    if (!new RegExp(selectedCountry.phone_regex).test(phone)) {
      setError('Некорректный номер телефона')
      return false
    }
    return true
  }

  const submitStep1 = (rawPhone = phone) => {
    if (!phoneValidation(rawPhone)) {
      return
    }
    step1(rawPhone)
  }

  return (
    <div className={styles.wrapper}>
      {/*<GoogleReCaptcha onVerify={t => setToken(t)} />*/}
      <div className={styles.wrapper_description}>
        Для восстановления доступа укажите телефон, который привязан к вашему счету, в поле ниже.
      </div>
      <div className={styles.wrapper_label}>
        Номер телефона
      </div>
      <CountryPhone />
      <Button name='ДАЛЕЕ' onClick={() => submitStep1()} />
      <div className={styles.grecaptcha}>
        This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target='_blank' rel='noopener noreferrer'>Privacy
          Policy</a> and <a href="https://policies.google.com/terms" target='_blank' rel='noopener noreferrer'>Terms of Service</a> apply.
      </div>
    </div>
  );
};

export default PhoneStep;
